import { APP_EVENTS, APP_VIEW, CHAT, GA, LIVESDK_EVENTS, EVENT_EVENTS, PARENT_ACTION, USER, VIDEO } from './constants';
import * as appStore from './store/app';
export default class PostMessageHandler {
  constructor(ctrl, store) {
    this.ctrl = ctrl;
    this.store = store;
    if (this.isRenderedInIframe()) {
      this.bindCtrlEvents();
      this.bindPostMessageEvents();
    }
  }
  isRenderedInIframe() {
    return window.location !== window.parent.location;
  }
  sendMessage(message) {
    if (this.isRenderedInIframe()) {
      let parentDomain = document.referrer;
      if (parentDomain === '') {
        parentDomain = window.top.location.origin;
      }
      try {
        window.parent.postMessage(message, parentDomain);
      } catch (err) {
        console.error(err);
      }
    }
  }

  bindCtrlEvents() {
    let ctrlEventValues = [];
    const ctrlEvents = APP_EVENTS;
    Object.keys(ctrlEvents).forEach((key) => {
      ctrlEventValues.push(ctrlEvents[key]);
    });
    ctrlEventValues.forEach((event, index, arr) => {
      const funcName = this[event.replace('app', '__onApp')];
      if (funcName && typeof funcName === 'function') {
        this.ctrl.on(event, funcName.bind(this));
      }
    });
  }

  __onAppNextMediaRequested(data) {
    const payload = {
      action: APP_EVENTS.NEXT_MEDIA_REQUESTED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatHistory(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_HISTORY,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatSent(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_SENT,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppEventStatusChange(data) {
    const payload = {
      action: EVENT_EVENTS.STATUS_CHANGED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatReceived(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_RECIEVED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatDelete(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_DELETED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatPin(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_PINNED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatUnPin(data) {
    const payload = {
      action: LIVESDK_EVENTS.CHAT_UNPINNED,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppQnaHistory(data) {
    const payload = {
      action: LIVESDK_EVENTS.QNA_HISTORY,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppQnaSent(data) {
    const payload = {
      action: LIVESDK_EVENTS.QNA_SENT,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatLoginRequest(data) {
    const payload = {
      action: CHAT.REQUEST_LOGIN,
    };
    this.sendMessage(payload);
  }

  __onAppGaEvent(data) {
    const payload = {
      action: GA.GA_EVENT,
      data: data,
    };
    this.sendMessage(payload);
  }

  __onAppChatCLose() {
    const payload = {
      action: CHAT.CLOSE_CHAT,
    };
    this.sendMessage(payload);
  }
  __onAppVideoEnded() {
    const payload = {
      action: VIDEO.VIDEO_ENDED,
    };
    this.sendMessage(payload);
  }

  __onAppUserConnected(data) {
    const payload = {
      action: USER.USER_CONNECTED,
      data: {
        eventid: data?.state?.ID,
        userid: data?.userid,
        status: data?.state?.Status,
      },
    };
    this.sendMessage(payload);
  }

  __onAppEnvReady() {
    const payload = {
      action: APP_EVENTS.READY_TO_USE,
    };
    this.sendMessage(payload);
  }

  bindPostMessageEvents() {
    try {
      window.addEventListener('message', (event) => {
        const { action } = event.data;
        if (action) {
          this.handleParentActions(event.data);
        }
      });
    } catch (err) {
      console.error('bind iframe event', err);
    }
  }

  handleParentActions(eventData) {
    const { app } = this.store.getState();
    const { view } = app;
    const { action, data } = eventData;
    if (view !== APP_VIEW.MAIN && action !== PARENT_ACTION.CREATE_SESSION) return;
    switch (action) {
      case PARENT_ACTION.DESTROY_PLAYER_ON_BG:
        this.destroyPlayer();
        break;
      case PARENT_ACTION.RESUME_PLAYER_ON_FG:
        this.reloadPlayer();
        break;
      case PARENT_ACTION.PLAY:
        this.play();
        break;
      case PARENT_ACTION.PAUSE:
        this.pause();
        break;
      case PARENT_ACTION.GET_CHAT_HISTORY:
        this.getChatHistory(data);
        break;
      case PARENT_ACTION.GET_QNA_HISTORY:
        this.getQnaHistory();
        break;
      case PARENT_ACTION.SEND_MESSAGE:
        this.sendChatMessage(data);
        break;
      case PARENT_ACTION.SEND_QNA:
        this.sendQna(data);
        break;
      case PARENT_ACTION.CREATE_SESSION:
        this.createSession(data);
        break;
      default:
        break;
    }
  }

  destroyPlayer() {
    try {
      this.ctrl?.player?.cPlayer?.destroyPlayerOnBg();
    } catch (err) {
      console.error('Failed to destroy player');
      return;
    }
  }

  reloadPlayer() {
    try {
      this.ctrl?.player?.cPlayer?.resumePlayerOnFg();
    } catch (err) {
      console.error('Failed to reload player');
      return;
    }
  }

  play() {
    try {
      this.ctrl?.player?.play();
    } catch (err) {
      console.error('Failed to play');
      return;
    }
  }

  pause() {
    try {
      this.ctrl?.player?.pause();
    } catch (err) {
      console.error('Failed to pause');
      return;
    }
  }

  getChatHistory(data) {
    try {
      if (data?.pageno) this.ctrl?.LiveSdk?.getChatHistory(data?.pageno);
      else this.ctrl?.LiveSdk?.getChatHistory();
    } catch (err) {
      console.error('Failed to get chat history');
      return;
    }
  }
  sendChatMessage(data) {
    try {
      this.ctrl?.LiveSdk?.sendMessage(data?.message);
    } catch (err) {
      console.error('Failed to send message');
      return;
    }
  }

  getQnaHistory() {
    try {
      this.ctrl?.LiveSdk?.getQnaHistory();
    } catch (err) {
      console.error('Failed to get qna history');
      return;
    }
  }

  sendQna(data) {
    try {
      this.ctrl?.LiveSdk?.sendQna(data?.message);
    } catch (err) {
      console.error('Failed to send qna');
      return;
    }
  }

  createSession(data) {
    try {
      if (data && Object.keys(data).length) {
        this.store.dispatch(appStore.setClientConfig(data));
      }
      this.ctrl.createSession();
    } catch (err) {
      console.error('Failed to create session:', err);
      return;
    }
  }
}
